<template>
  <div style="position: relative">
    <div class="unpaid-screen" v-if="!paid">
      <h1>Dostęp do komentarzy zablokowany.</h1>
      <p>Wykup pakiet, by odblokować funkcję.</p>
      <button>Wykup</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Comments",
  data() {
    return {
      isCheckedReadFilter: true,
      isCheckedUnreadFilter: true,
      loadingComments: true,
      paid: false
    };
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.wrapper {
  padding-top: 5px;
  z-index: -1;
  flex: 1;
  display: flex;
  overflow-y: auto;
  height: calc(100% - 62px);
}

.unpaid-screen {
  width: 100%;
  height: calc(100vh - 82px);
  background: rgba(0, 0, 0, 0.85);
  padding: 15px;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 15;

  & h1 {
    margin: 0;
    padding: 0;
  }

  & p {
    color: #aaa;
  }
}
</style>
